import { render, staticRenderFns } from "./CreateAConfrontation.vue?vue&type=template&id=75d62026&"
import script from "./CreateAConfrontation.vue?vue&type=script&lang=js&"
export * from "./CreateAConfrontation.vue?vue&type=script&lang=js&"
import style0 from "./CreateAConfrontation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports